// User selectors
export const selectUser = (state) => state.reducer.user?.data || null;
export const selectUserLoading = (state) => state.reducer.user?.loading || false;
export const selectUserError = (state) => state.reducer.user?.error || null;
export const selectIsAuthenticated = (state) => !!state.reducer.user?.data;
export const selectIsAdmin = (state) => !!state.reducer.isAdmin;
